<template>
    <v-app id="main-app" class="app-bg">
        <div class="loading-overlay" v-if="isLoading">
            <v-layout align-center justify-center class="fill-height">
                <v-row class="text-center">
                    <v-col cols="12">
                        <h3 class="loading-text">{{ $t('general.loading')}}</h3>
                    </v-col>
                    <v-col cols="6" offset="3">
                        <v-progress-linear rounded indeterminate color="#3a36a8"/>
                    </v-col>
                </v-row>
            </v-layout>
        </div>

        <div id="page-header" class="page-header">
<!--            <div class="px-16 py-4 text-end">
                <v-btn text dark>
                    Domov
                </v-btn>

                <v-btn text dark>
                    Video prenos
                </v-btn>

                <v-btn text dark>
                    Foto galerija
                </v-btn>
            </div>-->

            <v-menu left bottom>
                <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" class="lang-btn ma-3" small fab outlined dark>{{$store.getters.currentLanguage}}</v-btn>
                </template>

                <v-list>
                    <v-list-item @click="changeLanguage('en')">
                        <v-list-item-title>{{$t('general.english')}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changeLanguage('sl')">
                        <v-list-item-title>{{$t('general.slovenian')}}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <!--<v-btn class="lang-btn" small fab>{{$store.getters.currentLanguage}}</v-btn>-->
        </div>

        <v-main>
            <main-page @dataLoaded="isLoading = false" @dataLoading="isLoading = true"/>
        </v-main>

        <v-footer padless color="#FFFFFF" id="page-footer">
            <v-col
                    class="text-center"
                    cols="12"
            >
                <p class="footer-text">&#169{{ new Date().getFullYear() }} — <strong>Bezovšek family</strong></p>
            </v-col>
        </v-footer>
    </v-app>
</template>

<script>

    import MainPage from "./views/MainPage";

    export default {
        name: 'App',

        components: {
            MainPage
        },

        data: () => ({
            snowFallInterval: null,
            isLoading: true
        }),

        created() {
            const vm = this;

            if (vm.$route.query && vm.$route.query.lang) {
                if (vm.$route.query.lang === 'en' || vm.$route.query.lang === 'sl') {
                    vm.$store.commit('setLanguage', vm.$route.query.lang);
                }
            }
        },
        mounted() {
            const vm = this;

            vm.snowFallInterval = setInterval(() => {
                vm.createSnowFlake();
            }, 50);

            const appHeight = () => {

                let body = document.body;
                let html = document.documentElement;

                let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

                const doc = document.documentElement
                doc.style.setProperty('--app-height', `${height}px`)
            }
            window.addEventListener('resize', appHeight);
            appHeight()
        },
        destroyed() {
            const vm = this;

            clearInterval(vm.snowFallInterval);
            vm.snowFallInterval = null;
        },
        methods: {
            createSnowFlake() {
                let container = document.getElementById('main-app');

                const snowFlake = document.createElement('i');
                snowFlake.classList.add('fa');
                snowFlake.classList.add('fa-snowflake-o');
                snowFlake.classList.add('snowflake-item-header');
                snowFlake.style.left = container.offsetLeft + Math.random() * container.offsetWidth + 'px';
                snowFlake.style.animationDuration = Math.random() * 5 + 5 + 's';
                snowFlake.style.opacity = Math.random();
                snowFlake.style.fontSize = Math.random() * 10 + 10 + 'px';

                setTimeout(() => {
                    snowFlake.remove();
                }, 10000);

                container.appendChild(snowFlake);
            },

            changeLanguage(l) {
                const vm = this;
                vm.$i18n.locale = l;
                vm.$store.commit('setLanguage', l);
                vm.$router.replace({ query: { lang: l } })
            }
        }
    };
</script>

<style lang="scss">

    body {
        position: relative;
        margin: 0 !important;
        overflow-y: hidden;
        overflow-x: hidden;
    }

    :root {
        --app-height: 100%;
    }

    .loading-overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.8);
        z-index: 2000;
    }

    .loading-text {
        color: rgb(57, 54, 168);
    }

    .app-bg {
        //background-color: #514df7 !important;
        background: rgb(57, 54, 168) !important;
        background: -moz-linear-gradient(90deg, rgba(57,54,168,1) 0%, rgba(81,77,247,1) 50%, rgba(119,116,251,1) 100%) !important;
        background: -webkit-linear-gradient(90deg, rgba(57,54,168,1) 0%, rgba(81,77,247,1) 50%, rgba(119,116,251,1) 100%) !important;
        background: linear-gradient(90deg, rgba(57,54,168,1) 0%, rgba(81,77,247,1) 50%, rgba(119,116,251,1) 100%) !important;
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#3936a8",endColorstr="#7774fb",GradientType=1) !important;
    }

    .header-image {
        width: 100%;
    }

    .v-image__image {
        background-size: contain !important;
    }

    .v-main {
        padding: 0 !important;
    }

    .v-footer {
        z-index: 10 !important;
    }

    .footer-text {
        color: rgb(57,54,168);
        margin: 0 !important;
    }

    .lang-btn {
        position: absolute;
        top: 0;
        right: 0;
        margin: 1%;
        z-index: 2 !important;
    }

    .snowflake-item-header {
        animation: snowfall linear forwards;
        animation-duration: 15s;
        color: #ffffff;
        position: absolute;
        top: -20px;
        z-index: 9 !important;
    }

    @keyframes snowfall {
        to {
            transform: translateY(200vh);
        }
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        @keyframes snowfall {
            to {
                transform: translateY(var(--app-height));
            }
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {

    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {

    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {

    }
</style>
